import React from "react";
import { Outlet, useLocation, useNavigate } from "react-router-dom";

export default function AdminLayout(): JSX.Element {
  const location = useLocation();
  const navigate = useNavigate();

  return (
    <div className="mx-auto flex max-w-7xl flex-wrap">
      <div className="w-full">
        <ul
          className="mx-1 mb-0 flex list-none flex-row flex-wrap pb-4 pt-3"
          role="tablist"
        >
          <li className="-mb-px mr-2 mt-2 flex-auto text-center last:mr-0 cursor-pointer">
            <a
              className={
                "block rounded px-5 py-3 text-xs font-bold uppercase leading-normal shadow-lg " +
                (location.pathname.endsWith("users")
                  ? "bg-primary text-white"
                  : "bg-white text-primary")
              }
              onClick={(e) => {
                navigate("/admin/users");
              }}
              data-toggle="tab"
              role="tablist"
            >
              Users
            </a>
          </li>
          <li className="-mb-px mr-2 mt-2 flex-auto text-center last:mr-0 cursor-pointer">
            <a
              className={
                "block rounded px-5 py-3 text-xs font-bold uppercase leading-normal shadow-lg " +
                (location.pathname.endsWith("companies")
                  ? "bg-primary text-white"
                  : "bg-white text-primary")
              }
              onClick={(e) => {
                navigate("/admin/companies");
              }}
              data-toggle="tab"
              role="tablist"
            >
              Companies
            </a>
          </li>
          <li className="-mb-px mr-2 mt-2 flex-auto text-center last:mr-0 cursor-pointer">
            <a
              className={
                "block rounded px-5 py-3 text-xs font-bold uppercase leading-normal shadow-lg " +
                (location.pathname.endsWith("learning")
                  ? "bg-primary text-white"
                  : "bg-white text-primary")
              }
              onClick={(e) => {
                navigate("/admin/learning");
              }}
              data-toggle="tab"
              role="tablist"
            >
              Learning
            </a>
          </li>
          <li className="-mb-px mr-2 mt-2 flex-auto text-center last:mr-0 cursor-pointer">
            <a
              className={
                "block rounded px-5 py-3 text-xs font-bold uppercase leading-normal shadow-lg " +
                (location.pathname.endsWith("files")
                  ? "bg-primary text-white"
                  : "bg-white text-primary")
              }
              onClick={(e) => {
                navigate("/admin/files");
              }}
              data-toggle="tab"
              role="tablist"
            >
              Files
            </a>
          </li>
          <li className="-mb-px mr-2 mt-2 flex-auto text-center last:mr-0 cursor-pointer">
            <a
              className={
                "block rounded px-5 py-3 text-xs font-bold uppercase leading-normal shadow-lg " +
                (location.pathname.endsWith("system")
                  ? "bg-primary text-white"
                  : "bg-white text-primary")
              }
              onClick={(e) => {
                navigate("/admin/system");
              }}
              data-toggle="tab"
              role="tablist"
            >
              System
            </a>
          </li>

        </ul>
        <div className="relative mb-6 flex w-full min-w-0 flex-col break-normal">
          <div className="flex-auto px-4 py-5">
            <Outlet />
          </div>
        </div>
      </div>
    </div>
  );
}
